import React from 'react';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';

import { FormattedMessage, useIntl } from '../../util/reactIntl';
import * as validators from '../../util/validators';
import { FieldTextInput, Form, PrimaryButton } from '../../components';

import css from './ContactChevalierForm.module.css';

const ContactChevalierForm = props => {
  const {
    className,
    emailInvalidId = 'ContactChevalierForm.emailInvalid',
    emailLabelId = 'ContactChevalierForm.emailLabel',
    emailRequiredId = 'ContactChevalierForm.emailRequired',
    error: externalError = null,
    formIdPrefix = 'ContactChevalierForm',
    inProgress: externalInProgress = false,
    messageLabelId = 'ContactChevalierForm.messageLabel',
    messagePlaceholderId = 'ContactChevalierForm.messagePlaceholder',
    messageRequiredId = 'ContactChevalierForm.messageRequired',
    nameLabelId = 'ContactChevalierForm.nameLabel',
    nameRequiredId = 'ContactChevalierForm.nameRequired',
    submitErrorId = 'ContactChevalierForm.submitError',
    submitId = 'ContactChevalierForm.submit',
    submittingId = 'ContactChevalierForm.submitting',
    ...rest
  } = props;

  return (
    <FinalForm
      {...rest}
      render={formRenderProps => {
      const { handleSubmit } = formRenderProps;
      const intl = useIntl();

      const nameRequired = validators.requiredAndNonEmptyString(
        intl.formatMessage({ id: nameRequiredId })
      );
      const emailRequired = validators.required(
        intl.formatMessage({ id: emailRequiredId })
      );
      const emailValid = validators.emailFormatValid(
        intl.formatMessage({ id: emailInvalidId })
      );
      const messageRequired = validators.requiredAndNonEmptyString(
        intl.formatMessage({ id: messageRequiredId })
      );

      return (
        <Form className={classNames(css.root, className)} onSubmit={handleSubmit}>
          <FieldTextInput
            className={css.field}
            id={`${formIdPrefix}.senderName`}
            name="senderName"
            type="text"
            label={intl.formatMessage({ id: nameLabelId })}
            validate={nameRequired}
          />
          <FieldTextInput
            className={css.field}
            id={`${formIdPrefix}.senderEmail`}
            name="senderEmail"
            type="email"
            label={intl.formatMessage({ id: emailLabelId })}
            validate={validators.composeValidators(emailRequired, emailValid)}
          />
          <FieldTextInput
            className={css.field}
            id={`${formIdPrefix}.message`}
            name="message"
            type="textarea"
            label={intl.formatMessage({ id: messageLabelId })}
            placeholder={intl.formatMessage({ id: messagePlaceholderId })}
            validate={messageRequired}
          />

          {externalError ? (
            <p className={css.error}>
              <FormattedMessage id={submitErrorId} />
            </p>
          ) : null}

          <div className={css.actions}>
            <PrimaryButton
              type="submit"
              inProgress={externalInProgress}
              disabled={externalInProgress}
            >
              <FormattedMessage id={externalInProgress ? submittingId : submitId} />
            </PrimaryButton>
          </div>
        </Form>
      );
      }}
    />
  );
};

export default ContactChevalierForm;
